import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import MarkdownRenderer from "@/components/MarkdownRenderer";
import SubscribeForm from "@/components/SubscribeForm";

function coverSrc(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/posts/${slug}`);
        setPost(data);
      } catch (e) {
        setErr("Post not found.");
      }
    })();
  }, [slug]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-24 text-muted-foreground font-mono">[ {err} ]</div>;
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24 text-muted-foreground font-mono">[ loading ]</div>;

  const cover = coverSrc(post.cover_image);

  return (
    <div data-testid="blog-post">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 lg:pt-20">
        <Link to="/insights" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground link-underline">
          <ArrowLeft className="w-3.5 h-3.5" /> Back to insights
        </Link>
        <div className="mt-10 flex items-center justify-between">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-accent">{post.tag}</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {new Date(post.created_at).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}
          </span>
        </div>
        <h1 className="mt-6 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.1]">{post.title}</h1>
        <p className="mt-6 text-lg text-muted-foreground italic">{post.excerpt}</p>
      </div>

      {cover && (
        <div className="max-w-5xl mx-auto px-6 lg:px-10 my-12">
          <div className="rounded-2xl overflow-hidden border border-border">
            <img src={cover} alt="" className="w-full max-h-[520px] object-cover" />
          </div>
        </div>
      )}

      <article className="max-w-3xl mx-auto px-6 lg:px-10 pb-16">
        <MarkdownRenderer>{post.body}</MarkdownRenderer>
      </article>

      <div className="max-w-3xl mx-auto px-6 lg:px-10 pb-24">
        <SubscribeForm />
      </div>
    </div>
  );
}
